import { render } from "./Content.vue?vue&type=template&id=6b267da7"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=6b267da7&lang=scss"
script.render = render

export default script